import { render, staticRenderFns } from "./systemwlAdmin.vue?vue&type=template&id=34c36f56&scoped=true&"
import script from "./systemwlAdmin.vue?vue&type=script&lang=js&"
export * from "./systemwlAdmin.vue?vue&type=script&lang=js&"
import style0 from "./systemwlAdmin.vue?vue&type=style&index=0&id=34c36f56&scoped=true&lang=css&"
import style1 from "./systemwlAdmin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c36f56",
  null
  
)

export default component.exports